import { TiposPerfilSite, TYPES } from './types'
import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects'
import * as loadingActions from 'store/modules/loading/actions'
import * as profissionalActions from 'store/modules/cadastros/profissional/actions'
import * as profissionalController from 'controller/profissionalController'
import * as cadastroInicialController from 'controller/cadastroInicialController'
import { PROFISSIONAL } from './types'
import { ApplicationState } from 'store'
import { handlerError } from 'util/handlerError'
import { toast } from 'react-toastify'
import { removeMaskMoney } from 'util/masks'
import history from 'util/history'

interface GenericProps {
  type: string
}

function* getPerfis(): SagaIterator {
  try {
    yield put(loadingActions.setLoading(true))
    const response = yield call(profissionalController.getPerfis)
    yield put(
      profissionalActions.setOptionsSelect(response?.data?.content, 'perfis')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* getEstados(): SagaIterator {
  try {
    yield put(profissionalActions.setLoadingOptionsSelect(true, 'estados'))
    const response = yield call(profissionalController.getEstados)
    yield put(
      profissionalActions.setOptionsSelect(response?.data?.content, 'estados')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(profissionalActions.setLoadingOptionsSelect(false, 'estados'))
  }
}

interface GetCidadesProps extends GenericProps {
  value: string
}

function* getCidades({ value }: GetCidadesProps): SagaIterator {
  try {
    yield put(profissionalActions.setLoadingOptionsSelect(true, 'cidades'))
    const response = yield call(profissionalController.getCidades, value)
    yield put(
      profissionalActions.setOptionsSelect(response?.data?.content, 'cidades')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(profissionalActions.setLoadingOptionsSelect(false, 'cidades'))
  }
}

function* getConvenios(): SagaIterator {
  try {
    yield put(profissionalActions.setLoadingOptionsSelect(true, 'convenios'))
    const response = yield call(profissionalController.getConvenios)
    yield put(
      profissionalActions.setOptionsSelect(response?.data?.content, 'convenios')
    )
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(profissionalActions.setLoadingOptionsSelect(false, 'convenios'))
  }
}

function* cadastroAposentado(): SagaIterator {
  const { cadastroAposentado }: PROFISSIONAL = yield select(
    (state: ApplicationState) => state.profissional
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(profissionalController.cadastroAposentado, {
      matricula: cadastroAposentado.matricula,
      salario: Number(removeMaskMoney(cadastroAposentado.salario)),
      siglaEstado: cadastroAposentado.siglaEstado,
      cidadeId: cadastroAposentado.cidadeId
    })
    // history.push('/validacao')
    history.push('/margens-disponiveis')
    toast.success('Informações salvas com sucesso')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* atualizarMargens(): SagaIterator {
  const { margensDisponiveis }: PROFISSIONAL = yield select(
    (state: ApplicationState) => state.profissional
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(profissionalController.atualizarMargens, {
      margemCartaoBeneficio: Number(
        removeMaskMoney(margensDisponiveis.margemCartaoBeneficio)
      ),
      margemCartaoConsignado: Number(
        removeMaskMoney(margensDisponiveis.margemCartaoConsignado)
      ),
      margemConsignado: Number(
        removeMaskMoney(margensDisponiveis.margemConsignado)
      )
    })
    yield call(cadastroInicialController.atualizarContatoRDStation, null, {
      cf_site_margem_consignado: margensDisponiveis.margemConsignado,
      cf_site_margem_cartao_consignado:
        margensDisponiveis.margemCartaoConsignado,
      cf_site_margem_cartao_beneficio: margensDisponiveis.margemCartaoBeneficio,
      tags: ['etapa_margens_disponiveis']
    })
    history.push('/simulacao')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* cadastroServidor(): SagaIterator {
  const { cadastroServidor }: PROFISSIONAL = yield select(
    (state: ApplicationState) => state.profissional
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(profissionalController.cadastroServidor, {
      matricula: cadastroServidor.matricula,
      convenioId: cadastroServidor.convenioId,
      salario: Number(removeMaskMoney(cadastroServidor.salario)),
      siglaEstado: cadastroServidor.siglaEstado,
      cidadeId: cadastroServidor.cidadeId,
      margemEmprestimoConsignado: Number(
        removeMaskMoney(cadastroServidor.margemEmprestimoConsignado)
      ),
      margemCartaoConsignado: Number(
        removeMaskMoney(cadastroServidor.margemCartaoBeneficio)
      ),
      margemCartaoBeneficio: Number(
        removeMaskMoney(cadastroServidor.margemCartaoBeneficio)
      ),
      servidoresPublicoEnum: cadastroServidor.servidoresPublicoEnum ?? 3
    })
    history.push('/simulacao')
    toast.success('Informações salvas com sucesso')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* cadastroClt(): SagaIterator {
  const { cadastroClt }: PROFISSIONAL = yield select(
    (state: ApplicationState) => state.profissional
  )
  try {
    yield put(loadingActions.setLoading(true))
    yield call(profissionalController.cadastroClt, {
      salario: Number(removeMaskMoney(cadastroClt.salario)),
      siglaEstado: cadastroClt.siglaEstado,
      cidadeId: cadastroClt.cidadeId
    })
    history.push('/simulacao')
    toast.success('Informações salvas com sucesso')
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

function* atualizarRDStation(): SagaIterator {
  const { tipoPerfil, cadastroClt, cadastroAposentado }: PROFISSIONAL =
    yield select((state: ApplicationState) => state.profissional)

  const descricaoPerfil = tipoPerfil !== null ? TiposPerfilSite[tipoPerfil] : ''

  try {
    yield put(loadingActions.setLoading(true))

    switch (tipoPerfil) {
      case TiposPerfilSite.APOSENTADO:
        yield call(cadastroInicialController.atualizarContatoRDStation, null, {
          cf_site_eu_sou: descricaoPerfil,
          cf_site_matricula_beneficio: cadastroAposentado.matricula,
          cf_site_salario: removeMaskMoney(cadastroAposentado.salario),
          state: cadastroAposentado.siglaEstado,
          tags: ['etapa_eusou', 'etapa_informacoes']
        })

        break

      case TiposPerfilSite.CLT:
        yield call(cadastroInicialController.atualizarContatoRDStation, null, {
          cf_site_eu_sou: descricaoPerfil,
          cf_site_salario: removeMaskMoney(cadastroClt.salario),
          state: cadastroClt.siglaEstado,
          tags: ['etapa_eusou', 'etapa_informacoes']
        })

        break
    }
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}
function* updateEuSou(): SagaIterator {
  const { tipoPerfil }: PROFISSIONAL = yield select(
    (state: ApplicationState) => state.profissional
  )

  const descricaoPerfil = tipoPerfil !== null ? TiposPerfilSite[tipoPerfil] : ''
  try {
    yield put(loadingActions.setLoading(true))
    yield call(cadastroInicialController.atualizarContatoRDStation, null, {
      cf_site_eu_sou: descricaoPerfil,
      tags: ['etapa_informacoes']
    })
  } catch (error) {
    handlerError(error)
  } finally {
    yield put(loadingActions.setLoading(false))
  }
}

export function* watchGetPerfis() {
  yield takeEvery(TYPES.GET_PERFIS_SAGA, getPerfis)
}

export function* watchGeEstados() {
  yield takeEvery(TYPES.GET_ESTADOS_SAGA, getEstados)
}

export function* watchGetCidades() {
  yield takeEvery(TYPES.GET_CIDADES_SAGA, getCidades)
}

export function* watchGetConvenios() {
  yield takeEvery(TYPES.GET_CONVENIOS_SAGA, getConvenios)
}

export function* watchCadastroAposentado() {
  yield takeEvery(TYPES.CADASTRAR_APOSENTADO_SAGA, cadastroAposentado)
}

export function* watchCadastroServidor() {
  yield takeEvery(TYPES.CADASTRAR_SERVIDOR_SAGA, cadastroServidor)
}

export function* watchCadastroClt() {
  yield takeEvery(TYPES.CADASTRAR_CLT_SAGA, cadastroClt)
}
export function* watchAtualizarMargens() {
  yield takeEvery(TYPES.ATUALIZAR_MARGENS_SAGA, atualizarMargens)
}

export function* watchAtualizarRDStation() {
  yield takeEvery(TYPES.ATUALIZAR_RD_STATION_SAGA, atualizarRDStation)
}
export function* watchUpdateEuSou() {
  yield takeEvery(TYPES.UPDATE_EU_SOU_SAGA, updateEuSou)
}
function* profissional() {
  yield all([
    fork(watchGetPerfis),
    fork(watchGeEstados),
    fork(watchGetCidades),
    fork(watchGetConvenios),
    fork(watchCadastroAposentado),
    fork(watchCadastroServidor),
    fork(watchCadastroClt),
    fork(watchAtualizarMargens),
    fork(watchAtualizarRDStation),
    fork(watchUpdateEuSou)
  ])
}

export default profissional
